import * as React from 'react';
import {
	DateField,
	Show,
	ShowProps,
	SimpleShowLayout,
	TextField,
} from 'react-admin';

export const LiveTrainingMessageShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<TextField source="content" label="CONTENT"/>
				<DateField source="date" label="DATE"/>
			</SimpleShowLayout>
		</Show>
	);
};
